<template>
  <div id="applications">
    <div class="title">
      我的申请
    </div>
    <div class="list">
      <div class="application">
        <div v-for="application in applications" v-bind:key="application.id">
          <div class="name">
            <span>{{ application.merchantName }}</span>
          </div>
          <div class="applicationDate">
            {{ application.createTime }}
          </div>
          <div class="status">
            <span v-if="application.status === 0 && application.auditResult" class="reject-reason">{{ application.auditResult }}</span>
            <span v-else-if="application.status === 0 && !application.auditResult">
              审核中
            </span>
            <span v-else>审核成功</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {queryApplicationsByOpenId} from '../modules/services/basic-service'

export default {
  name: 'applications',
  data () {
    return {
      applications: [
        {
          merchantName: '张小东测试',
          createTime: '2019-01-23 23:12:22',
          status: 0,
          id: 1,
          auditResult: ''
        }
      ]
    }
  },
  created () {
    if (!this.$route.query.openId) {
      this.$router.push({
        path: '/authorize-fail?reason=未获取到微信用户ID'
      })
    } else {
      const self = this
      self.applicant = this.$route.query.openId
      queryApplicationsByOpenId(this.$route.query.openId).then(({body}) => {
        if (body) {
          self.applications = body
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  #applications {
    .title {
      color: dodgerblue
      font-size: 20px;
      font-weight: bolx;
      padding: 10px 20px;
      text-align left
      border-bottom 1px solid #ccc
    }
    .list {
      margin-top: 10px;
      .application {
        padding 5px 10px;
      }
    }
  }
</style>